// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1xqkv","content":"Consent_content__3PFLx","footer":"Consent_footer__29lei"};